// src/utils/codigoMoto.js

// ✅ Named export
export function normalizeToken(s = "") {
  return s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quita acentos
    .toUpperCase()
    .replace(/\s+/g, "")             // quita espacios
    .replace(/[^A-Z0-9]/g, "");      // solo A-Z0-9
}

/**
 * Genera código: YYYYMMDDHHmmss_MARCA_MODELO_ANO
 * - marca/modelo: normalizados (mayúsculas, sin espacios/acentos)
 * - ano: dígitos (opcional)
 */
export function generateCodigoMoto({ marca = "", modelo = "", ano = "", date = new Date() } = {}) {
  const y  = date.getFullYear();
  const m  = String(date.getMonth() + 1).padStart(2, "0");
  const d  = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  const marcaTok  = normalizeToken(marca) || "X";
  const modeloTok = normalizeToken(modelo) || "X";
  const anoTok    = String(ano || "").replace(/\D/g, "");

  // YYYYMMDDHHmmss_MARCA_MODELO_ANO
  return `${y}${m}${d}${hh}${mm}${ss}_${marcaTok}_${modeloTok}_${anoTok}`;
}